function getFlagEmoji(countryCode) {
	const codePoints = countryCode
		.toUpperCase()
		.split('')
		.map(char => 127397 + char.charCodeAt())
	return String.fromCodePoint(...codePoints)
}

function getContentLanguageLabel(l, displayLocale = 'en') {
	const locale = new Intl.Locale(l)
	const code = locale.region
	const namesEn = new Intl.DisplayNames([displayLocale], { type: 'language' })

	return `${getFlagEmoji(code)} ${namesEn.of(locale.language)}`
}

export default getContentLanguageLabel
